var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"qq-quick-booking-container qui-quo-container",attrs:{"data-booking":0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }